module.exports = __webpack_public_path__ + "static/media/heathermint.40c4613b.jpg";